export enum EQuoteType {
  Carpet,
  Upholstery,
  Protector,
  Area_Rug,
  Stairs,
  Hard_Surface,
  Other,
}
